const authorFromScratch = {
  topicId: "nualang.author-from-scratch.0.0.1",
  topicName: "ゼロからの作者",
  description: "",
  difficulty: "ALL",
  learnLang: "japanese",
};

export default authorFromScratch;
